  import { baotangso, trolyao, thongbao, nhiemvu, nghiquyet } from 'assets/images';
  const technologies = [
  {
    title: 'Bảo tàng số',
    imgSrc: baotangso,
    description: 'VR360 hỗ trợ người dùng xem được toàn cảnh bảo tàng số'
  },
  {
    title: 'Trợ lý ảo',
    imgSrc: trolyao,
    description: 'Được giải đáp thắc mắc bởi trí tuệ nhân tạo AI. Là xu hướng công nghệ được đón đầu'
  },
  {
    title: 'Thông báo nội bộ',
    imgSrc: thongbao,
    description: 'Được xem những thông báo trong phạm vi nội bộ nhanh nhất ở đơn vị'
  },
  {
    title: 'Nhiệm vụ',
    imgSrc: nhiemvu,
    description: 'Hỗ trợ phân công nhiệm vụ và thực hiện nhiệm vụ Đảng trong tổ chức'
  },
  {
    title: 'Nghị quyết',
    imgSrc: nghiquyet,
    description: 'Đưa ra nghị quyết cho buổi sinh hoạt Đảng, Chuyên đề, phục vụ cho công tác tổ chức Đảng'
  },
  {
    title: 'Bảo tàng số',
    imgSrc: baotangso,
    description: 'VR360 hỗ trợ người dùng xem được toàn cảnh bảo tàng số'
  },
  {
    title: 'Trợ lý ảo',
    imgSrc: trolyao,
    description: 'Được giải đáp thắc mắc bởi trí tuệ nhân tạo AI. Là xu hướng công nghệ được đón đầu'
  },
  {
    title: 'Thông báo nội bộ',
    imgSrc: thongbao,
    description: 'Được xem những thông báo trong phạm vi nội bộ nhanh nhất ở đơn vị'
  },
  {
    title: 'Nhiệm vụ',
    imgSrc: nhiemvu,
    description: 'Hỗ trợ phân công nhiệm vụ và thực hiện nhiệm vụ Đảng trong tổ chức'
  },
  {
    title: 'Nghị quyết',
    imgSrc: nghiquyet,
    description: 'Đưa ra nghị quyết cho buổi sinh hoạt Đảng, Chuyên đề, phục vụ cho công tác tổ chức Đảng'
  },
  {
    title: 'Bảo tàng số',
    imgSrc: baotangso,
    description: 'VR360 hỗ trợ người dùng xem được toàn cảnh bảo tàng số'
  },
  {
    title: 'Trợ lý ảo',
    imgSrc: trolyao,
    description: 'Được giải đáp thắc mắc bởi trí tuệ nhân tạo AI. Là xu hướng công nghệ được đón đầu'
  },
  {
    title: 'Thông báo nội bộ',
    imgSrc: thongbao,
    description: 'Được xem những thông báo trong phạm vi nội bộ nhanh nhất ở đơn vị'
  },
  {
    title: 'Nhiệm vụ',
    imgSrc: nhiemvu,
    description: 'Hỗ trợ phân công nhiệm vụ và thực hiện nhiệm vụ Đảng trong tổ chức'
  },
  {
    title: 'Nghị quyết',
    imgSrc: nghiquyet,
    description: 'Đưa ra nghị quyết cho buổi sinh hoạt Đảng, Chuyên đề, phục vụ cho công tác tổ chức Đảng'
  }
];

export default technologies;
